import React, { useCallback, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useRange } from "react-instantsearch";
import Accordion from "../../../UI/Accordion/Accordion";
import { addDays, subDays } from "date-fns";

import de from "date-fns/locale/de";

import "./CustomDatePicker.scss";

const CustomDatePicker = (props) => {
    const { canRefine, refine, range } = useRange(props);
    const [shippingDays, setShippingDays] = useState();
    const [currentDate] = useState(new Date());
    const isWeekday = (date) => {
        const day = date.getDay(date);
        return day !== 0 && day !== 6;
    };
    const [startDate, setStartDate] = useState(null);

    const refineShippingDays = useCallback(() => {
        let shippingTime;
        let days;
        shippingTime = startDate ? startDate - currentDate : null;
        days = Math.abs(Math.round(shippingTime / (1000 * 3600 * 24)));
        setShippingDays(days);
    }, [currentDate, startDate]);

    useEffect(() => {
        startDate !== "" && refineShippingDays();
        // eslint-disable-next-line
    }, [startDate]);

    useEffect(() => {
        shippingDays && refine([undefined, shippingDays]);

        // eslint-disable-next-line
    }, [shippingDays]);

    return (
        <>
            {canRefine && range ? (
                <Accordion header={props.panelTitle}>
                    <DatePicker
                        className="search-filter__datepicker"
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        includeDateIntervals={[
                            {
                                start: subDays(new Date(), 1),
                                end: addDays(new Date(), range.max),
                            },
                        ]}
                        filterDate={isWeekday}
                        showWeekNumbers
                        dateFormat="dd.MM.yyyy"
                        weekLabel="KW"
                        disabledKeyboardNavigation
                        startDate={startDate}
                        locale={de}
                        placeholderText="dd.mm.yyyy"
                        inline
                    />
                </Accordion>
            ) : null}
        </>
    );
};

export default CustomDatePicker;
